<nav class="nav-body">
  @for (menuItem of mainMenuItems$ | async; track menuItem) {
    <app-navigation-menu-item [item]="menuItem"></app-navigation-menu-item>
  }

  @if (settingsMenuItems$ | async; as settingsMenuItems) {
    @if (settingsMenuItems.length > 0) {
      <hr class="divider" />
    }
    @for (menuItem of settingsMenuItems; track menuItem) {
      <app-navigation-menu-item [item]="menuItem"></app-navigation-menu-item>
    }
  }
  @if (intercomEnabled$ | async) {
    <emperor-nav-button
      class="nav-menu-item"
      [highlight]="false"
      [stopPropagation]="false"
      (click)="openContactUs()"
    >
      <emperor-icon name="bp_user_chat" class="nav-icon"></emperor-icon>
      Contact Us
    </emperor-nav-button>
  }

  @if (debugDrawerAvailable) {
    <div class="debug-drawer-toggle">
      <mat-slide-toggle
        [checked]="debugDrawerVisible()"
        (change)="toggleDebugDrawer()"
        color="primary"
      >
        Debug drawer
      </mat-slide-toggle>
    </div>
  }

  <!-- Copyright -->
  <div class="copyright-info">
    <bp-sdk-footer></bp-sdk-footer>
    <div>©<app-year></app-year> Bold Penguin • All rights reserved</div>
    <div>
      <a href="https://www.boldpenguin.com/legal/terms-of-use"
        >Terms & Conditions</a
      >
      •
      <a href="https://privacy.boldpenguin.com/privacy-policy"
        >Privacy Policy</a
      >
    </div>
  </div>
</nav>
